import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import SideSearchbar from '../../components/SideSearchbar/'
import { GetClassifications, EditClassification, CreateClassification, DeleteClassification } from './ClassificationsAcction'
import { Container, DialogContentText, DialogContent, DialogTitle, DialogActions, Dialog, Grid, Button, TextField } from '@material-ui/core';
import OverLoader from '../../components/common/loader';
import '../../App.css'
import isEmpty from 'lodash.isempty';
import NumberFormat from 'react-number-format';
import numeral from 'numeral';
import 'numeral/locales/de'
import { LogoutAction } from '../../actions';
import { Prompt } from "react-router-dom";
numeral.locale('de');

class Classifications extends Component {

  constructor(props) {
    super(props);
    this.state = {
      listData: [],
      classificationField: '',
      probabilityField: '',
      classificationID: '',
      editMode: false,
      newClassification: '',
      editedClassification: '',
      deletedClasification: '',
      isDeleteContactDialogOpen: false,
      error: '',
      isBlocking: false,
      accessErrorDialog: false
    }

    this.baseState = this.state;
    this.textInput = React.createRef();

  }

  focusTextInput = () => {
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')

    if (Number(access_rights.classifications) === 2 && token !== null)
      this.textInput.current.focus();
  }

  listener = event => {
    const { editMode } = this.state
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      if (!editMode) {
        this.createClassification()
      } else {
        this.editClassificationData()
      }
    }
  };

  componentDidMount = () => {
    const { GetClassifications } = this.props
    document.addEventListener("keydown", this.listener);
    GetClassifications()
  }

  componentWillUnmount = () => {
    document.removeEventListener("keydown", this.listener);

  }
  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { classifications_list, access_error, new_classification, edited_classification, delete_success, error_validation, message_valid } = this.props
    const { classificationID } = this.state
    if (nextProps.classifications_list !== classifications_list) {
      this.setState({ listData: nextProps.classifications_list })
    }
    else if (nextProps.new_classification !== new_classification) {
      this.setState({ newClassification: nextProps.new_classification, editMode: true, classificationID: nextProps.new_classification.id, isBlocking: false })
    }
    else if (nextProps.edited_classification !== edited_classification) {
      this.setState({ editedClassification: nextProps.edited_classification, isBlocking: false })
    } else if (nextProps.delete_success !== delete_success) {
      this.setState({ deletedClasification: classificationID, editMode: false, classificationField: '', probabilityField: '', isBlocking: false })
    }
    if (nextProps.error_validation !== error_validation || nextProps.message_valid !== message_valid) {
      this.setState({ error: nextProps.error_validation })
    }
    if (nextProps.access_error !== access_error) {
      this.setState({ accessErrorDialog: true })
    }
  }

  getClassificationData = (item) => {
    const { isBlocking } = this.state
    if (!isBlocking) {
      let resProb = item.probability.replace(".", ",")
      this.setState({
        classificationID: item.id,
        classificationField: item.name,
        probabilityField: resProb,
        editMode: true,
        error: '',
      })
      setTimeout(() => {
        this.focusTextInput()
      }, 100)
    }
    else {
      let retVal = window.confirm("Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren?");

      if (retVal === true) {
        this.setState({ isBlocking: false }, () => this.getClassificationData(item))
      } else {
        this.setState({ isBlocking: false }, () => setTimeout(() => {
          this.setState({ isBlocking: true })
        }, 1000))
      }
    }
  }

  editClassificationData = () => {
    const { classificationID, classificationField, probabilityField } = this.state
    const { EditClassification } = this.props
    EditClassification(classificationID, classificationField, numeral(probabilityField).value())
  }

  createClassification = () => {
    const { CreateClassification } = this.props
    const { classificationField, probabilityField } = this.state
    CreateClassification(classificationField, numeral(probabilityField).value())
  }

  openDeleteDialog = () => {
    this.setState({ isDeleteContactDialogOpen: true })
  }
  closeDeleteContactDialog = () => {
    this.setState({ isDeleteContactDialogOpen: false })

  }

  deletedClasification = () => {
    const { DeleteClassification } = this.props
    const { classificationID } = this.state
    DeleteClassification(classificationID)
    this.setState({ isDeleteContactDialogOpen: false })
    setTimeout(() => {
      this.focusTextInput()
    }, 100)
  }

  resetForm = () => {
    this.setState({ classificationField: '', probabilityField: '', classificationID: '', editMode: false, error: '', })
    setTimeout(() => {
      this.focusTextInput()
    }, 200)
  }

  render() {
    const { deletedClasification, isBlocking, accessErrorDialog, error, probabilityField, isDeleteContactDialogOpen, editMode, listData, classificationField, newClassification, editedClassification } = this.state
    const { isloading, access_error } = this.props
    const access_rights = JSON.parse(localStorage.getItem('access_right'))
    const token = localStorage.getItem('access-token')
    if (token === null) {
      this.props.LogoutAction()
    }
    return (
      <div>
        {isloading && <OverLoader />}
        <Container maxWidth="xl">
          <Grid container spacing={3} className="mainBlock">
            {isEmpty(error.message) ?
              <Fragment>
                <Grid item md={3} sm={4} xs={12}>
                  <div className="leftSide">
                    <SideSearchbar
                      tittle={"Neue Einstufung"}
                      listData={listData}
                      newList={newClassification}
                      editedList={editedClassification}
                      deleteList={deletedClasification}
                      getDataOfSelectedItemFunc={this.getClassificationData}
                      createNewListFunc={this.resetForm}
                      isRight={Number(access_rights.classifications)}

                    />
                  </div>
                </Grid>
                <Grid item md={9} sm={8} xs={12}
                  className={`${Number(access_rights.classifications) === 1 ? "disableALlFields" : ""}`}
                >
                  <Prompt
                    when={isBlocking}
                    message={location =>
                      `Ihre Änderungen wurden nicht gepeichert. Möchten Sie trotzdem fortfahren? `
                    }
                  />
                  <div className="rightBlock liproCard">
                    <div className="mb2">
                      <label className="mb1">Einstufung</label>
                      <TextField
                        helperText={!isEmpty(error.classification) ? error.classification : ''} error={!isEmpty(error.classification) ? true : false}
                        inputRef={this.textInput}
                        size="small" value={classificationField} className="innerInput"
                        onChange={(e) => {
                          if (!isEmpty(error.classification))
                            error.classification = []
                          this.setState({ classificationField: e.target.value, isBlocking: true })
                        }} variant="outlined" />
                    </div>
                    <div className="mb2">
                      <label className="mb1">Wahrscheinlichkeit</label>
                      <NumberFormat
                        customInput={TextField}
                        className="innerInput rightToLeft"
                        required={true}
                        inputProps={{
                          maxLength: 40
                        }}
                        variant="outlined"
                        helperText={!isEmpty(error.probability) ? error.probability : ''} error={!isEmpty(error.probability) ? true : false}
                        value={probabilityField}
                        thousandSeparator='.'
                        decimalSeparator=","
                        decimalScale='2'
                        onChange={(e) => {
                          if (!isEmpty(error.probability))
                            error.probability = []
                          this.setState({ probabilityField: e.target.value, isBlocking: true })
                        }
                        }
                      />
                      <span style={{
                        display: 'inline-flex',
                        padding: '10px',
                        fontSize: '18px'
                      }}>%</span>
                    </div>
                    {Number(access_rights.classifications) !== 1 &&
                      <div className="actionBtn">
                        {editMode ?
                          <Button variant="outlined" color="primary" onClick={() => { this.editClassificationData() }} >Speichern</Button>
                          :
                          <Button variant="outlined" color="primary" onClick={() => { this.createClassification() }} >Hinzufügen</Button>
                        }
                        {editMode &&
                          <Button variant="outlined" color="secondary" onClick={() => { this.openDeleteDialog() }} >Löschen</Button>
                        }
                      </div>
                    }
                    <Dialog
                      open={isDeleteContactDialogOpen}
                    >
                      <DialogTitle>Einstufung löschen</DialogTitle>
                      <DialogContent>
                        <DialogContentText >
                          Sind Sie sicher?
              </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={this.deletedClasification} size="small" variant="outlined" color="primary" autoFocus>
                          Bestätigen
              </Button>
                        <Button onClick={this.closeDeleteContactDialog} size="small" variant="outlined" color="secondary">
                          Abbrechen
              </Button>
                      </DialogActions>
                    </Dialog>

                    <Dialog
                      open={accessErrorDialog}
                    >
                      <DialogTitle>Einstufung</DialogTitle>
                      <DialogContent>
                        <DialogContentText >
                          {access_error && access_error.message}
                        </DialogContentText>
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={() => this.setState({ accessErrorDialog: false })} size="small" variant="outlined" color="secondary" >
                          Abbrechen
              </Button>
                      </DialogActions>
                    </Dialog>
                  </div>
                </Grid>
              </Fragment>
              :
              <Grid item md={12} sm={12} xs={12}>
                <div className="rightBlock rightBlock-bgWhite user-system">
                  <h3>{error.message}</h3>
                </div>
              </Grid>
            }
          </Grid>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = ({ classifications }) => {
  return {
    isloading: classifications.loading,
    classifications_list: classifications.classifications_list,
    message_valid: classifications.message_valid,
    new_classification: classifications.new_classification,
    edited_classification: classifications.edited_classification,
    delete_success: classifications.success,
    error_validation: classifications.error_message,
    access_error: classifications.access_error,

  }
};

const mapDispatchToProps = dispatch => {
  return {
    // dispatching actions
    GetClassifications: () => dispatch(GetClassifications()),
    EditClassification: (id, name, prob) => dispatch(EditClassification(id, name, prob)),
    CreateClassification: (name, prob) => dispatch(CreateClassification(name, prob)),
    DeleteClassification: (id) => dispatch(DeleteClassification(id)),
    LogoutAction: () => dispatch(LogoutAction()),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Classifications)